import Settings from './Settings'

export default {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/project/:projectId/settings',
      component: Settings,
    },
  ],
}



// WEBPACK FOOTER //
// ./src/main/content/project/settings/settingsConfig.js